/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AttachUserSessionIssuerForm,
  AttachUserSessionIssuerForm$Outbound,
  AttachUserSessionIssuerForm$outboundSchema,
} from "../components/attachusersessionissuerform.js";

export type DetachUserSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DetachUserSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DetachUserSessionIssuerSecurity = {
  option1?: DetachUserSessionIssuerSecurityOption1 | undefined;
  option2?: DetachUserSessionIssuerSecurityOption2 | undefined;
};

export type DetachUserSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  attachUserSessionIssuerForm: AttachUserSessionIssuerForm;
};

/** @internal */
export type DetachUserSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DetachUserSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DetachUserSessionIssuerSecurityOption1$Outbound,
    DetachUserSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function detachUserSessionIssuerSecurityOption1ToJSON(
  detachUserSessionIssuerSecurityOption1:
    DetachUserSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    DetachUserSessionIssuerSecurityOption1$outboundSchema.parse(
      detachUserSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type DetachUserSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DetachUserSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DetachUserSessionIssuerSecurityOption2$Outbound,
    DetachUserSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function detachUserSessionIssuerSecurityOption2ToJSON(
  detachUserSessionIssuerSecurityOption2:
    DetachUserSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    DetachUserSessionIssuerSecurityOption2$outboundSchema.parse(
      detachUserSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type DetachUserSessionIssuerSecurity$Outbound = {
  Option1?: DetachUserSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: DetachUserSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DetachUserSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  DetachUserSessionIssuerSecurity$Outbound,
  DetachUserSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DetachUserSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DetachUserSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function detachUserSessionIssuerSecurityToJSON(
  detachUserSessionIssuerSecurity: DetachUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    DetachUserSessionIssuerSecurity$outboundSchema.parse(
      detachUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type DetachUserSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AttachUserSessionIssuerForm: AttachUserSessionIssuerForm$Outbound;
};

/** @internal */
export const DetachUserSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  DetachUserSessionIssuerRequest$Outbound,
  DetachUserSessionIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    attachUserSessionIssuerForm: AttachUserSessionIssuerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      attachUserSessionIssuerForm: "AttachUserSessionIssuerForm",
    });
  }),
);

export function detachUserSessionIssuerRequestToJSON(
  detachUserSessionIssuerRequest: DetachUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    DetachUserSessionIssuerRequest$outboundSchema.parse(
      detachUserSessionIssuerRequest,
    ),
  );
}
